import React, { useEffect, useState } from 'react';
import ClientPortalLayout from './Layout';
import { clientPortalFetch } from './api';
import { formatDate } from './Dashboard';

const EXT_COLORS = {
  pdf: { color: '#dc2626', bg: '#fef2f2' },
  jpg: { color: '#d97706', bg: '#fffbeb' }, jpeg: { color: '#d97706', bg: '#fffbeb' },
  png: { color: '#16a34a', bg: '#f0fdf4' },
  doc: { color: '#2563eb', bg: '#eff6ff' }, docx: { color: '#2563eb', bg: '#eff6ff' },
  xlsx: { color: '#059669', bg: '#f0fdf4' }, xls: { color: '#059669', bg: '#f0fdf4' },
  zip: { color: '#7c3aed', bg: '#f5f3ff' },
};

const formatSize = (bytes) => {
  if (!bytes) return '';
  return bytes > 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${(bytes / 1024).toFixed(0)} KB`;
};

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function DocumentsInner() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    clientPortalFetch('/documents').then(setDocs).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const handleDownload = async (doc) => {
    try {
      const data = await clientPortalFetch(`/documents/${doc.id}/download`);
      window.open(`${BASE}${data.url}`, '_blank');
    } catch (e) {
      alert(e.message);
    }
  };

  if (loading) return <p style={{ color: '#9ca3af', fontSize: 13 }}>Loading…</p>;
  if (docs.length === 0) {
    return (
      <div style={{ padding: '48px 0', textAlign: 'center', background: '#fff', borderRadius: 12, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        <p style={{ fontSize: 14, fontWeight: 600, color: '#374151', margin: 0 }}>No documents yet</p>
        <p style={{ fontSize: 12, color: '#9ca3af', marginTop: 4 }}>Your firm will upload documents here as they become available.</p>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {docs.map((doc) => {
        const ext = EXT_COLORS[doc.file_type] || { color: '#6b7280', bg: '#f3f4f6' };
        return (
          <div key={doc.id} style={{
            background: '#fff', borderRadius: 12, padding: '14px 16px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            display: 'flex', alignItems: 'center', gap: 14,
          }}>
            <div style={{
              width: 40, height: 40, borderRadius: 10, background: ext.bg, color: ext.color,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 10, fontWeight: 700, textTransform: 'uppercase', flexShrink: 0,
            }}>
              {doc.file_type || 'FILE'}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ fontSize: 13, fontWeight: 600, color: '#111827', margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{doc.file_name}</p>
              <div style={{ display: 'flex', gap: 10, marginTop: 3, flexWrap: 'wrap', fontSize: 11, color: '#9ca3af' }}>
                <span>{doc.task_title}</span>
                {doc.description && <span>· {doc.description}</span>}
                {formatSize(doc.file_size) && <span>· {formatSize(doc.file_size)}</span>}
                <span>· {formatDate(doc.created_at)}</span>
              </div>
            </div>
            <button onClick={() => handleDownload(doc)} style={{
              width: 34, height: 34, borderRadius: 8, border: 'none', background: '#eff6ff',
              display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0,
            }}>
              <svg width="15" height="15" fill="none" stroke="#2563eb" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3" />
              </svg>
            </button>
          </div>
        );
      })}
    </div>
  );
}

function Documents() {
  return <ClientPortalLayout title="Documents"><DocumentsInner /></ClientPortalLayout>;
}

export default Documents;
